import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Form, Input, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { responsive } from "../../utils/style";
import { onCreateNextMatch, setIsSuccess } from "../../stores/editProfile";
import CompletedModal from "../../components/EditProfile/Modal";
import {
  SubmitButton,
  DateField,
  FieldContainer,
  CustomSelect,
  Option,
} from "../../components/CustomFields";

moment.locale("th");
moment.tz("Asia/Bangkok");

const disabledDate = (current, endMatchDate) => {
  if (current && current < moment().endOf("day")) return true;
  else if (current && moment(current).day() !== 1) return true;
  return current && current < moment(endMatchDate).endOf("day");
};

const NextMatchForm = (props) => {
  const dispatch = useDispatch();
  const { isSuccess } = useSelector((state) => state.editProfile);
  const [form] = Form.useForm();
  const onFinish = (values) => dispatch(onCreateNextMatch(values));
  const onClose = () => {
    dispatch(setIsSuccess(false));
    props.onSuccess();
  };

  useEffect(() => {
    form.setFieldsValue({ name: "เกมเณรกล้า โภชนาดี ครั้งที่ 2" });
  }, []);

  return (
    <Container>
      <Background>
        <CompletedModal visible={isSuccess} onClose={onClose} />
        <ProfileWrapper>
          <Topic>กำหนดวันเริ่มการแข่งขันของเกมถัดไป</Topic>
          <StyleForm
            form={form}
            name="nextMatchForm"
            layout="vertical"
            onFinish={onFinish}
          >
            <FieldContainer
              name="name"
              label="ชื่อกิจกรรมในการแข่งขัน"
              required={false}
              rules={[{ required: true, message: "โปรดระบุ" }]}
              marginBottom={0}
            >
              <Input placeholder="โปรดระบุ" />
            </FieldContainer>
            <DateField
              name="startDate"
              label="วันเริ่มต้นของการแข่งขัน"
              required={false}
              rules={[{ required: true, message: "โปรดระบุ" }]}
              marginBottom={0}
            >
              <DatePicker
                placeholder="โปรดระบุ"
                disabledDate={(current) =>
                  disabledDate(current, props.endMatchDate)
                }
              />
            </DateField>
            <FieldContainer
              name="maxWeek"
              label="จำนวนสัปดาห์ที่แข่งขัน"
              required={false}
              rules={[{ required: true, message: "โปรดระบุ" }]}
              marginBottom={0}
            >
              <CustomSelect placeholder="โปรดระบุ" width="100%" widthRs="100%">
                {[4, 8, 12, 16].map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))}
              </CustomSelect>
            </FieldContainer>
            <Form.Item shouldUpdate>
              {() => (
                <SubmitWrapper>
                  <SubmitButton
                    htmlType="submit"
                    disabled={
                      !form.isFieldsTouched(true) ||
                      !!form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    บันทึก
                  </SubmitButton>
                </SubmitWrapper>
              )}
            </Form.Item>
          </StyleForm>
        </ProfileWrapper>
      </Background>
    </Container>
  );
};

export default NextMatchForm;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  .ant-form-item {
    margin-bottom: 24px;

    ${responsive.mobile(css`
      margin-bottom: 16px;
    `)}
  }
`;
const Background = styled.div`
  min-height: 100vh;
  max-width: 1144px;
  background-color: white;
  margin: auto;
  padding: 40px 0;

  ${responsive.tablet(css`
    max-width: unset;
  `)}
  ${responsive.mobile(css`
    padding: 40px 16px;
  `)}
`;
const ProfileWrapper = styled.div`
  max-width: 440px;
  margin: auto;
`;
const Topic = styled.h4`
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  margin: 0;
  align-self: flex-end;
`;
const StyleForm = styled(Form)`
  margin-top: 40px;

  .ant-input-number {
    width: 100%;
  }
  input {
    border-radius: 4px;
    height: 52px;
    font-size: 18px;
  }
  .ant-input-affix-wrapper {
    font-size: 18px;
  }
  .ant-select-selector {
    height: 52px !important;
    font-size: 18px;
  }
  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    line-height: 52px !important;
    font-size: 18px;
  }
  .ant-picker {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }
  .ant-picker-input {
    padding-bottom: 0 !important;
  }
`;
const SubmitWrapper = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 16px;
`;
